export default "__VITE_ASSET__CLz8LpC2__"